import { cashSummaryApi } from "../../api";

const CashSummaryService = {
  /**
   * 📊 Obtener resumen financiero de una sesión de caja
   * GET /api/cash/summary/session/{sessionId}
   */
  getSummary: async (sessionId: number) => {
    const response = await cashSummaryApi.fetchCustom(`/session/${sessionId}`);
    return response.data;
  }
};

export default CashSummaryService;